import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";

export type CardTitleComponentProps = {};

export type CardTitleProps<T extends React.ElementType> =
    PolymorphicComponentProps<
        T,
        CardTitleComponentProps,
        "div" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
    >;

const CardTitle = <T extends React.ElementType = "div">({
    tag,
    className,
    ...attributes
}: CardTitleProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { title } = card({});

    return (
        <Tag
            {...attributes}
            className={title({ className })}
        />
    );
};

export { CardTitle };
